import { dv } from '../i18n/dv.ts';
import type { MeetingRow } from '../features/meetings/api.ts';

export type MeetingStatusKey =
  | 'SCHEDULED' | 'AGENDA_FINALIZED' | 'AGENDA_SENT'
  | 'YAUMIYYA_PROGRESS' | 'YAUMIYYA_DONE' | 'COMPLETED' | 'CANCELLED';

type StatusInput = Pick<MeetingRow, 'status' | 'agendaPassedAt' | 'yaumiyya' | 'completedAt'>;

// The single overall status (haalathu) for a meeting, following the lifecycle:
// scheduled → agenda finalized → agenda sent (signed + emailed) → yaumiyya in
// progress → yaumiyya passed. Cancelled overrides everything.
export function meetingStatusKey(m: StatusInput): MeetingStatusKey {
  if (m.status === 'CANCELLED') return 'CANCELLED';
  if (m.completedAt) return 'COMPLETED';
  const y = m.yaumiyya?.status;
  if (y === 'APPROVED') return 'YAUMIYYA_DONE';
  if (y === 'DRAFT' || y === 'PENDING_APPROVAL') return 'YAUMIYYA_PROGRESS';
  if (m.agendaPassedAt) return 'AGENDA_SENT';
  if (m.status === 'AGENDA_FINALIZED') return 'AGENDA_FINALIZED';
  return 'SCHEDULED';
}

const PILL: Record<MeetingStatusKey, string> = {
  SCHEDULED: 'pill pill-active',
  AGENDA_FINALIZED: 'pill pill-active',
  AGENDA_SENT: 'pill pill-active',
  YAUMIYYA_PROGRESS: 'pill pill-pending',
  YAUMIYYA_DONE: 'pill pill-success',
  COMPLETED: 'pill pill-success',
  CANCELLED: 'pill pill-neutral',
};

export function meetingStatus(m: StatusInput): { label: string; pill: string } {
  const key = meetingStatusKey(m);
  return { label: dv.meetings.status[key] ?? key, pill: PILL[key] };
}
